import moment from "moment";

import { Popup } from "@/Common/Components/Modals/Popup";
import * as LocalPatientOperations from "@/Common/Operations/operations.patient.local";
import { LocalEvent } from "@/Common/Stores/Actions/LocalEvent";
import { IPatientMedicalNoteModel } from "@/Patient/Models/UI/MedicalNote/IPatientMedicalNoteModel";

interface IPatientMedicalNoteAlreadyApprovedWarningProps {
    NoteModel: IPatientMedicalNoteModel;
}

class MedicalNoteAlreadyAprovedWarningPopup extends React.Component<IPatientMedicalNoteAlreadyApprovedWarningProps, any> {
    private id: string = "newnotepopupmenu";

    public render(): JSX.Element {
        var signoffDate = this.props.NoteModel.get("ConcurrentEditSignedOffDate");
        var signoffById = this.props.NoteModel.get("ConcurrentEditSignedOffBy");
        var signoffBy = cacheStore.GetCliniciansPersonsByContactFacetId(signoffById);
        let signoffByName = (signoffBy != null) ? signoffBy.NameWithPrefix : "Id:" + signoffById;

        var title = cacheStore.GetString("WarningLabel");

        var msg = cacheStore.GetString("NoteAlreadySignedOff1Label");
        msg += " " + signoffByName + "(" + moment(signoffDate).format("YYYY-MM-DD HH:mm:SS") + " )";

        return (
            <Popup
                Id={this.id}
                title={title}
                closeTarget={LocalPatientOperations.MedicalSummary.NewNoteWarningCancel}
                draggable
                manageOverlay
                cssClass="memo"
            >
                <div className="p-body">
                    <div>
                        <span> {msg} </span>
                    </div>
                    <div>
                        <span> {cacheStore.GetString("ClickingLabel")} {cacheStore.GetString("OnLowerLabel")} </span> <strong> {cacheStore.GetString("ContinueLabel")} </strong>  <span> {cacheStore.GetString("NoteAlreadySignedOff2Label")} </span>
                    </div>
                    <div>
                        <span> {cacheStore.GetString("ClickingLabel")} {cacheStore.GetString("OnLowerLabel")} </span> <strong> {cacheStore.GetString("CancelLabel")} </strong>  <span> {cacheStore.GetString("NoteAlreadySignedOff3Label")} </span>
                    </div>
                </div>
                <div className="p-footer">
                    <div className="row">
                        <div className="col-lg-12 col-md-12 col-sm-12 columns text-right">
                            <div>
                                <div>
                                    <button className="btn btn-default push-right-5" onClick={this.CancelClick.bind(this)}> {cacheStore.GetString("CancelLabel")}</button>
                                    <button className="btn btn-default" onClick={this.ContinueNoteClick.bind(this)}>{cacheStore.GetString("ContinueLabel")} </button>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </Popup>
        );
    }

    private CancelClick(): void {
        var operation = new LocalEvent(LocalPatientOperations.MedicalNote.ConcurrentWarningPopup_ViewCurrent);
        LocalEventDispatcher.dispatch(operation);
    }

    private ContinueNoteClick(): void {
        var operation = new LocalEvent(LocalPatientOperations.MedicalNote.ConcurrentWarningPopup_NewNote);
        LocalEventDispatcher.dispatch(operation);
    }
}

export { MedicalNoteAlreadyAprovedWarningPopup };
